import React from "react";
import {Customers} from "../../context/CustomersContext";
import {Grid, Typography} from "@material-ui/core";
import ProgressOr from "../../components/ProgressOr";
import {SiteReport} from "./SiteReport";
import {PersonReport} from "./PersonReport";
import {makeStyles} from "@material-ui/styles";

const useStyles = makeStyles(() => {
    return {
        report: {
            maxWidth: 800
        }
    }
})

class Reports extends React.Component{
    constructor(props) {
        super(props);
        this.state = {}
        this.fetchCustomers()
    }

    fetchCustomers(){
        this.props.customersContext.fetchCustomers().then(customers => {
            this.setState({
                customers: customers
            })
        })
    }

    content(){
        const className = this.props.classes.report
        return (
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Typography variant="h1">Reports</Typography>
                </Grid>
                <Grid item xs={12}>
                    <SiteReport className={className} customers={this.state.customers} {...this.props}/>
                </Grid>
                <Grid item xs={12}>
                    <PersonReport className={className}/>
                </Grid>
            </Grid>
        )
    }

    render(){
        const loading = !this.state.customers
        return (
            <ProgressOr showProgress={loading} progressMessage={"Loading customers..."}>
                {loading ? "" : this.content()}
            </ProgressOr>
        )
    }
}

export default function(props){
    const classes = useStyles()
    return (
        <Customers.Consumer>
            {customers => (
                <Reports classes={classes} customersContext={customers} {...props}/>
            )}
        </Customers.Consumer>
    )
}